import React, { FunctionComponent, useEffect, useState, useContext } from 'react';
import {
  Card,
  CardHeader,
  Collapse,
  IconButton,
  CardContent,
  Typography,
  Divider,
  Grid,
  Button,
  Link,
} from '@material-ui/core';
import Icon from '@mdi/react';
import {
  mdiChevronDown,
  mdiChevronUp,
  mdiMapMarkerOutline,
  mdiPhone,
  mdiContentCopy,
} from '@mdi/js';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import jMoment from 'moment-jalaali';
import { withRouter } from 'react-router-dom';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '90%',
      margin: '20px auto ',

      '& .MuiTypography-colorTextSecondary': {
        color: 'white',
        fontSize: '14px',
      },
    },
    header: {
      backgroundColor: '#1C6E7D',
    },
    headercod: {
      backgroundColor: '#1B68FF',
    },
    address: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
      justifyContent: 'left',
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
      justifyContent: 'center',
    },
    divider: {
      width: '85%',
      margin: '8px auto',
    },
    rtlIcon: {
      marginRight: theme.spacing(1),
      transform: 'scale(-1, 1)',
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    button: {
      padding: '10px 25px',
    },
  })
);

const DriverCard = (props: any) => {
  const classes = useStyles();
  const [toggleHeader, setToggleHeader] = useState<boolean>(false);
  const [isCopied, setIsCopied] = useState<boolean>(false);
  return (
    <Card
      ref={props.draggableProvided.innerRef}
      {...props.draggableProvided.draggableProps}
      {...props.draggableProvided.dragHandleProps}
      style={{
        ...props.draggableProvided.draggableProps.style,
        background: props.snapshot.isDragging
          ? 'rgba(245,245,245, 0.75)'
          : 'none',
      }}
      className={classes.root}
    >
      <CardHeader
        className={props.data.paymentType === 'COD' ? classes.headercod : classes.header}
        action={
          <IconButton
            aria-label="settings"
            onClick={() => {
              setToggleHeader(!toggleHeader);
            }}
          >
            <Icon
              path={toggleHeader ? mdiChevronUp : mdiChevronDown}
              size={1}
            />
          </IconButton>
        }
        subheader={`سفارش ${props.data.id} | ${props.data.customerName}`}
      />
      <CardContent>
        <Typography variant="body2" color="textSecondary" component="p">
          {props.data.customerLat !== null ? (
            <span className={classes.address}>
              <span>
                <Icon
                  path={mdiMapMarkerOutline}
                  size={1}
                  className={classes.icon}
                />
              </span>
              <span
                style={{
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  color: 'blue',
                }}
                onClick={() =>
                  window.open(
                    `https://www.google.com/maps/search/?api=1&query=${props.data.customerLat}%2C${props.data.customerLon}`
                  )
                }
              >
                {props.data.customerAddress}
              </span>
            </span>
          ) : (
            <span className={classes.address}>
              <Icon
                path={mdiMapMarkerOutline}
                size={1}
                className={classes.icon}
              />
              {props.data.customerAddress}
            </span>
          )}
          <div style={{ marginTop: '20px', textAlign: 'left' }} >
            <Button variant='outlined' endIcon={
              <Icon
                path={mdiContentCopy}
                size={1}
                className={classes.icon}
              />
            }
              onClick={() => { navigator.clipboard?.writeText(props.data.customerAddress); setIsCopied(true) }}
              style={{ backgroundColor: 'rgba(28, 110, 125, 0.2)', color: '#1C6E7D' }}
            >
              {isCopied ? 'آدرس کپی شد' : 'کپی آدرس'}
            </Button>
          </div>
        </Typography>
      </CardContent>
      <Divider className={classes.divider} />
      <Collapse in={toggleHeader} timeout="auto" unmountOnExit>
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{'تعداد بسته:  '}</span>

                <span>{props.data.itemsCount}</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{'بازه تحویل:  '}</span>
                <span>
                  <span>
                    {jMoment(props.data.deliveryDate, 'YYYY/M/D')
                      .locale('fa')
                      .format('jYY/jMM/jDD')}
                  </span>
                  &nbsp; &nbsp;- &nbsp; &nbsp;
                  <span>
                    {`${jMoment(props.data.deliveryStartTime, 'HH:mm:ss')
                      .locale('fa')
                      .format('HH')}
                        `}
                    {`تا ${jMoment(props.data.deliveryEndTime, 'HH:mm:ss')
                      .locale('fa')
                      .format('HH')}`}
                  </span>
                </span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} container alignItems="center">
              <Grid item xs={8}>
                <div className={classes.item}>
                  <span className={classes.label}>{'شماره تماس:  '}</span>

                  <span>{props.data.customerMobileNumber}</span>
                </div>
              </Grid>
              <Grid item xs={4}>
                <Link href={`tel:${props.data.customerMobileNumber}`}>
                  <Icon
                    style={{
                      backgroundColor: '#D7E3FC',
                      color: '#3875F1',
                      borderRadius: '50px',
                      padding: '5px',
                    }}
                    path={mdiPhone}
                    size={1.5}
                    className={classes.icon}
                  />
                </Link>{' '}
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
        <Divider className={classes.divider} />
      </Collapse>
      <Grid
        container
        spacing={2}
        justifyContent="center"
        style={{ marginBottom: '6px' }}
      >
        <Grid item container xs={6} justifyContent="center">
          {props.data.paymentType === 'COD' ? (

            <Button
              className={classes.button}
              type="submit"
              size="medium"
              data-cy="search"
              variant="contained"
              style={{backgroundColor:'#1B68FF',color:'white'}}
              onClick={() => props.deliveredHandler(props.data.id, 'DELIVERED',props.data.codPaymentCode,props.data.codValue)}
            >
              {`دریافت مبلغ سفارش`}
            </Button>
          ) : (

            <Button
              className={classes.button}
              type="submit"
              size="medium"
              data-cy="search"
              variant="contained"
              color="primary"
              onClick={() => props.deliveredHandler(props.data.id, 'DELIVERED')}
            >
              {`تحویل داده شد`}
            </Button>
          )
          }
        </Grid>
        <Grid item container xs={6} justifyContent="center">
          <Button
            className={classes.button}
            variant="outlined"
            color="secondary"
            onClick={() =>
              props.notDeliveredHandler(props.data.id, 'NOT_DELIVERED')
            }
            size="medium"
            data-cy="search"
          >
            {`تحویل داده نشد`}
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
};
export default withRouter(DriverCard);
